import { useMemo } from 'react';
import { FlightsShoppingPwaFlightInformationResults, InsuranceCriteriaInput } from '__generated__/api';

import { useStores } from '.';
import { toJS } from 'mobx';

type useFlightsDetailCriteriaInputType = Pick<
  FlightsShoppingPwaFlightInformationResults.Variables,
  'flightsDetailCriteria'
> & { insuranceCriteria: InsuranceCriteriaInput };

export const useFlightsDetailCriteriaInput = (): useFlightsDetailCriteriaInputType => {
  const { informationCriteriaStore, flightsSupportedAncillariesStore } = useStores();
  const {
    journeyContinuationId,
    originalBookingId,
    upsellOfferToken
  } = informationCriteriaStore.informationCriteria.flightsDetailCriteria;
  const { sideSheetQueryContext } = informationCriteriaStore;
  const { selectedAncillaryId: ancillaryId } = flightsSupportedAncillariesStore;
  const addOnRequested = toJS(informationCriteriaStore.sideSheetTempValues.addOnRequested);
  const insuranceCriteria = informationCriteriaStore.insuranceCriteria;

  const inputs = useMemo(
    () => ({
      flightsDetailCriteria: {
        journeyContinuationId,
        ...(originalBookingId && { originalBookingId }),
        ...(upsellOfferToken && { upsellOfferToken }),
        ...(ancillaryId && { ancillaryId })
      },
      sideSheetQueryContext: {
        addOnRequested: addOnRequested,
        journeyContinuationId: sideSheetQueryContext.journeyContinuationId,
        isFirstLoad: sideSheetQueryContext.isFirstLoad
      },
      insuranceCriteria: {
        selectedProductId: insuranceCriteria?.selectedProductId ?? undefined
      }
    }),
    [
      journeyContinuationId,
      originalBookingId,
      upsellOfferToken,
      ancillaryId,
      addOnRequested,
      sideSheetQueryContext.journeyContinuationId,
      sideSheetQueryContext.isFirstLoad,
      insuranceCriteria
    ]
  );

  return inputs;
};
